import { Box, Button, Modal, Stack, Typography } from '@mui/material'
import XMarkSvg from '~/@ui/_sharedSvgs/FontAwesome/XMark.svg?react'

type Props = {
  isOpen: boolean
  handleClose: () => void
  title: string
  body: string
}

export const ViewDocumentModal = ({
  isOpen,
  handleClose,
  title,
  body,
}: Props) => {
  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Stack className="w-screen h-screen py-4 bg-white overflow-auto">
        <Button
          className="w-16 h-11 self-end mx-6 bg-zGrey200"
          onClick={handleClose}>
          <XMarkSvg />
        </Button>

        <Stack>
          <Typography className="text-2xl font-bold text-zBlack200 mx-5 pt-10 pb-4">
            {title}
          </Typography>
          <Box className="w-full h-1d bg-zGrey700" />
          <Box
            className="px-6 py-6"
            dangerouslySetInnerHTML={{ __html: body }}
          />
        </Stack>
      </Stack>
    </Modal>
  )
}
